/* eslint-disable @typescript-eslint/no-explicit-any */
import { eventUtil, MapComponent, MapInfoWindow, MapMarker } from '@marriott/mi-ui-library';
import { useClientEnvVarsStore } from '@marriott/mi-store-utils';
import { searchResultsState, useStore } from '../../../modules/store/searchResultsStore';
import { useEffect, useRef, useState } from 'react';
import { getTitleIconOutlet, useGetBreakpoint } from '../../../modules/utils/helpers';
import { SearchOutletMiniCard } from '../SearchOutletMiniCard';
import { miniCardHeight } from '../../../modules/utils/constants/constants';
import { GlobalStyle, StyledGoogleMapContainer } from './GoogleMapComponent.styles';
import { SearchMiniCardSlider } from '../SearchMiniCardSlider/index';
import clsx from 'clsx';
import { StyledErrorMessage } from '../../../molecules/AwpErrorMessage/AwpErrorMessage.styles';
import { awpErrorState, awpErrorStore } from '../../../modules/store/awpErrorStore';

export const GoogleMapComponent = (props: any) => {
  // const [latitude] = useState<number>(useStore((state: searchResultsState) => state.lat));
  // const [longitude] = useState<number>(useStore((state: searchResultsState) => state.long));
  const searchResultData = useStore((state: searchResultsState) => state.searchResultData);
  const searchResultMapData = JSON.parse(JSON.stringify(searchResultData));
  const [selectedOutlet, setSelectedOutlet] = useState<any>([]);
  const [showMiniCard, setShowMiniCard] = useState(false);
  // const [mapCenter, setMapCenter] = useState<any>({});
  const [activeMarker, setActiveMarker] = useState<any>();
  const [isMobileViewPort, setIsMobileViewPort] = useState(useGetBreakpoint() === 'mobile');
  const [updatedSearchData, setUpdateSearchData] = useState<any>(
    isMobileViewPort
      ? searchResultMapData?.edges?.sort((outlet1: any, outlet2: any) =>
          outlet1?.node?.id?.split('.')[0]?.toLowerCase().localeCompare(outlet2?.node?.id?.split('.')[0]?.toLowerCase())
        )
      : searchResultMapData?.edges
  );
  const mapRef = useRef<google.maps.Map | null>(null);
  const divRef = useRef(null);
  const [containerWidth, setContainerWidth] = useState(0);
  const errorMessage = awpErrorStore((state: awpErrorState) => state.errorMessage);
  const didZoomRef = useRef(false);
  const didCenterRef = useRef(false);
  const [uniqueMarkers, setUniqueMarkers] = useState<any>([]);
  const [currentSlideIndex, setcurrentSlideIndex] = useState(0);

  const GOOGLE_MAP_API_KEY: any = useClientEnvVarsStore.getState().envVarsObject['GOOGLE_MAP_API_KEY'];

  const mapOptions = {
    fullscreenControl: false,
    mapTypeControl: false,
    zoomControl: true,
    gestureHandling: 'greedy',
    mapId: 'ec5bb275520a7fc8',
    mapTypeId: 'roadmap',
  };

  useEffect(() => {
    const handleResize = (entries: any) => {
      for (const entry of entries) {
        if (entry.contentRect) {
          setContainerWidth(entry.contentRect.width);
        }
      }
    };

    const observer = new window.ResizeObserver(handleResize);
    if (divRef.current) {
      observer.observe(divRef.current);
    }
    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    const uniqueMarkers = updatedSearchData?.map((outlet: any) => {
      return {
        lat: outlet?.node?.property?.basicInformation?.latitude,
        lng: outlet?.node?.property?.basicInformation?.longitude,
      };
    });

    const uniqueByKeys = () => {
      const seen = new Set();
      const keys = ['lat', 'lng'];
      return uniqueMarkers?.filter((marker: any) => {
        const k = JSON.stringify(keys.map(key => marker[key]));
        return !seen.has(k) && seen.add(k);
      });
    };
    setUniqueMarkers(uniqueByKeys());
  }, []);

  const mapStyle = { height: '100%', width: '100%' };

  const getOutletIcon = (outlet: any) => {
    const similarOutlets = updatedSearchData?.filter(
      (outletList: any) =>
        outletList?.node?.property?.basicInformation?.latitude === outlet?.lat &&
        outletList?.node?.property?.basicInformation?.longitude === outlet?.lng
    );
    const iconClasses: any = [];
    similarOutlets?.map((outlet: any) => {
      iconClasses.push(getTitleIconOutlet(outlet?.node));
    });
    let iconClass = iconClasses?.some((value: boolean) => value === true) ? props?.diningIconPath : props?.barIconPath;

    if (
      selectedOutlet[0]?.node?.property?.basicInformation?.latitude === outlet?.lat &&
      selectedOutlet[0]?.node?.property?.basicInformation?.longitude === outlet?.lng
    )
      iconClass += ' active-map-pin';
    return iconClass + ' m-map-pin flex-map-pin pin-0';
  };

  const getMarkerLabelText = (outlet: any) => {
    const similarOutlets = updatedSearchData?.filter(
      (outletList: any) =>
        outletList?.node?.property?.basicInformation?.latitude === outlet?.lat &&
        outletList?.node?.property?.basicInformation?.longitude === outlet?.lng
    );
    if (similarOutlets?.length > 1) return ` (${similarOutlets?.length})`;
    else return ' ';
  };

  const getInfoWindowDetails = (outlet: any) => {
    return <SearchOutletMiniCard outlet={outlet} {...props} />;
  };

  const handleOutletSelection = (outlet: any) => {
    const similarOutlet = updatedSearchData?.filter(
      (outletList: any) =>
        outletList?.node?.property?.basicInformation?.latitude === outlet?.lat &&
        outletList?.node?.property?.basicInformation?.longitude === outlet?.lng
    );
    setSelectedOutlet(similarOutlet);
    if (isMobileViewPort) {
      const pos = {
        lat: outlet?.lat,
        lng: outlet?.lng,
      };
      mapRef?.current?.panTo(pos);
    }
    // setMapCenter({
    //   lat: selectedOutletInfo?.node?.property?.basicInformation?.latitude,
    //   lng: selectedOutletInfo?.node?.property?.basicInformation?.longitude,
    // });
    setShowMiniCard(true);
  };

  const getInfoWindowOffset = (index: number) => {
    if (selectedOutlet?.length === 1) return new window.google.maps.Size(0, -30);
    else {
      return new window.google.maps.Size(0, -(index * miniCardHeight + index * 10 + 20));
    }
  };

  const mapContent = () => {
    return uniqueMarkers?.map((outlet: any, index: number) => {
      return (
        <>
          <MapMarker
            label={{
              className: getOutletIcon(outlet),
              color:
                selectedOutlet[0]?.node?.property?.basicInformation?.latitude === outlet?.lat &&
                selectedOutlet[0]?.node?.property?.basicInformation?.longitude === outlet?.lng
                  ? 'black'
                  : 'white',
              fontSize: '16px',
              text: getMarkerLabelText(outlet),
            }}
            icon={{
              url: '',
              scaledSize: new (window as any).google.maps.Size(75, 20),
            }}
            position={{
              lat: outlet?.lat,
              lng: outlet?.lng,
            }}
            onClick={() => {
              setActiveMarker(index);
              getCurrentSlideIndex(index);
              handleOutletSelection(outlet);
              setTimeout(() => {
                const mapMarkers = document.getElementsByClassName('gm-style-iw-tc');
                Array.from(mapMarkers)?.forEach((mapMarker: any, index: number) => {
                  if (index !== 0) mapMarker?.classList.add('d-none');
                });
              }, 200);
            }}
          />

          {showMiniCard &&
            selectedOutlet?.length > 0 &&
            activeMarker === index &&
            (isMobileViewPort ? (
              <SearchMiniCardSlider
                searchResults={updatedSearchData}
                {...props}
                activeMarker={activeMarker}
                setActiveMarker={setActiveMarker}
                isMobileView={true}
                containerWidth={containerWidth}
                currentSlideIndex={currentSlideIndex}
                setcurrentSlideIndex={setcurrentSlideIndex}
                uniqueSearchMarkers={uniqueMarkers}
                handleOutletSelection={handleOutletSelection}
              />
            ) : selectedOutlet?.length > 2 ? (
              <MapInfoWindow
                position={{
                  lat: selectedOutlet[0]?.node?.property?.basicInformation?.latitude,
                  lng: selectedOutlet[0]?.node?.property?.basicInformation?.longitude,
                }}
                children={
                  <SearchMiniCardSlider
                    searchResults={selectedOutlet}
                    {...props}
                    isMobileView={false}
                    containerWidth={containerWidth}
                  />
                }
                options={{ pixelOffset: new window.google.maps.Size(0, -30) }}
              />
            ) : (
              selectedOutlet?.map((outlet: any, index: number) => (
                <MapInfoWindow
                  position={{
                    lat: outlet?.node?.property?.basicInformation?.latitude,
                    lng: outlet?.node?.property?.basicInformation?.longitude,
                  }}
                  children={getInfoWindowDetails(outlet)}
                  options={{ pixelOffset: getInfoWindowOffset(index) }}
                />
              ))
            ))}
        </>
      );
    });
  };

  const closeInfoWindow = () => {
    if (showMiniCard && selectedOutlet) {
      setActiveMarker(null);
      setcurrentSlideIndex(-1);
      setSelectedOutlet([]);
      setShowMiniCard(false);
    }
  };

  const onMapLoad = (map: google.maps.Map) => {
    mapRef.current = map;

    const markersLatLng = updatedSearchData?.map((outlet: any) => {
      return {
        lat: outlet?.node?.property?.basicInformation?.latitude,
        lng: outlet?.node?.property?.basicInformation?.longitude,
      };
    });

    // set boundaries for map based on lat/lng coordinates of markers
    if (markersLatLng.length > 0) {
      const bounds = new window.google.maps.LatLngBounds();
      markersLatLng.forEach(({ lat, lng }: { lat: any; lng: any }) =>
        bounds.extend(new window.google.maps.LatLng(lat, lng))
      );
      map.fitBounds(bounds);
    }
  };

  const handleCenterChange = () => {
    if (!didCenterRef.current) {
      didCenterRef.current = true;
      return;
    }
    if (mapRef.current) {
      const center = mapRef.current.getCenter();
      const lat = center?.lat();
      const lng = center?.lng();

      // This is to prevent Label change on initial Map Load
      // if (mapCenter?.lat !== lat && mapCenter?.lng !== lng)
      eventUtil.dispatch('updateCtaLabel', [{ lat: lat, lng: lng }]);
    }
  };

  const handleZoomChange = () => {
    if (!didZoomRef.current) {
      didZoomRef.current = true;
      return;
    }
    if (mapRef.current) {
      const center = mapRef.current.getCenter();
      const lat = center?.lat();
      const lng = center?.lng();
      eventUtil.dispatch('updateCtaLabel', [{ lat: lat, lng: lng }]);
    }
  };

  eventUtil.on('showInfoWindow', (index: number) => {
    const activeIndex = uniqueMarkers?.findIndex(
      (outlet: any) =>
        outlet?.lat === updatedSearchData[index]?.node?.property?.basicInformation?.latitude &&
        outlet?.lng === updatedSearchData[index]?.node?.property?.basicInformation?.longitude
    );
    if (activeIndex >= 0) {
      setActiveMarker(activeIndex);
      getCurrentSlideIndex(activeIndex);
    }
    setShowMiniCard(true);
    setSelectedOutlet([updatedSearchData[index]]);
    // setMapCenter({
    //   lat: updatedSearchData[index]?.node?.property?.basicInformation?.latitude,
    //   lng: updatedSearchData[index]?.node?.property?.basicInformation?.longitude,
    // });
  });

  eventUtil.on('hideInfoWindow', outlet => {
    setActiveMarker(null);
    setSelectedOutlet([outlet]);
    setShowMiniCard(false);
    setcurrentSlideIndex(-1);
  });

  eventUtil.on('updateActiveMarker', updatedActiveMarker => {
    setActiveMarker(updatedActiveMarker);
    getCurrentSlideIndex(updatedActiveMarker);
    handleOutletSelection(uniqueMarkers[updatedActiveMarker]);
  });

  // useEffect(() => {
  //   if (latitude !== 0 && longitude !== 0) {
  //     setMapCenter({ lat: latitude, lng: longitude });
  //   } else if (
  //     updatedSearchData &&
  //     updatedSearchData?.length > 0 &&
  //     !!updatedSearchData[0]?.node?.property?.basicInformation?.latitude &&
  //     !!updatedSearchData[0]?.node?.property?.basicInformation?.longitude
  //   ) {
  //     setMapCenter({
  //       lat: updatedSearchData[0]?.node?.property?.basicInformation?.latitude,
  //       lng: updatedSearchData[0]?.node?.property?.basicInformation?.longitude,
  //     });
  //   } else {
  //     setMapCenter({ lat: 0, lng: 0 });
  //   }
  // }, []);

  useEffect(() => {
    function handleResize() {
      // eslint-disable-next-line react-hooks/rules-of-hooks
      const mobileView = useGetBreakpoint() === 'mobile';
      setIsMobileViewPort(mobileView);
      setUpdateSearchData(
        mobileView
          ? searchResultMapData?.edges?.sort((outlet1: any, outlet2: any) =>
              outlet1?.node?.id
                ?.split('.')[0]
                ?.toLowerCase()
                .localeCompare(outlet2?.node?.id?.split('.')[0]?.toLowerCase())
            )
          : searchResultMapData?.edges
      );
    }
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const getCurrentSlideIndex = (activeMarker: number) => {
    const slideIndex = updatedSearchData?.findIndex(
      (outlet: any) =>
        outlet?.node?.property?.basicInformation?.latitude === uniqueMarkers[activeMarker]?.lat &&
        outlet?.node?.property?.basicInformation?.longitude === uniqueMarkers[activeMarker]?.lng
    );
    setcurrentSlideIndex(slideIndex);
  };

  return updatedSearchData && updatedSearchData?.length > 0 ? (
    <StyledGoogleMapContainer data-testid="google-map-component" id="google-map-component" ref={divRef}>
      {!isMobileViewPort && selectedOutlet?.length > 2 && <GlobalStyle />}
      {errorMessage && (
        <StyledErrorMessage
          data-component-name="m-awp-AWPErrorMessage"
          data-testid="awp-AWPErrorMessage"
          isEmpty={!errorMessage}
          className={clsx(
            'container awp-error-container p-0 mx-3 awp-additional-container',
            errorMessage ? 'error-message-active' : ''
          )}
        >
          <div
            className={clsx(
              'm-message-inline awp-error-message mt-3 mb-3',
              props[errorMessage as keyof typeof props] ? 'error-sev2' : 'info'
            )}
          >
            <div className="m-message-content-wrap">
              <div className="m-message-content">
                <span>
                  {props?.awperror[errorMessage as keyof typeof props]
                    ? props?.awperror[errorMessage as keyof typeof props]
                    : errorMessage}
                </span>
              </div>
            </div>
          </div>
        </StyledErrorMessage>
      )}
      <MapComponent
        googleMapsApiKey={GOOGLE_MAP_API_KEY}
        mapId="ec5bb275520a7fc8"
        mapHeight="100%"
        options={mapOptions}
        mapContainerStyle={mapStyle}
        // zoom={10}
        // center={mapCenter}
        children={mapContent()}
        onClick={closeInfoWindow}
        onDragStart={closeInfoWindow}
        onLoad={onMapLoad}
        onCenterChanged={handleCenterChange}
        onZoomChanged={handleZoomChange}
      />
    </StyledGoogleMapContainer>
  ) : (
    <div className={clsx('loadStyle', 'm-spinner-m')} data-testid="map-loader"></div>
  );
};
